import type { AdminSchemas } from "@esp/api-client/admin";
import { createContext, useContext } from "react";

export type Staff = AdminSchemas["StaffMe"];
export const STAFF_QUERY_KEY = ["staff-me"] as const;

export interface StaffApi {
  staff: Staff;
  signOut(): Promise<void>;
}

export const StaffContext = createContext<StaffApi | null>(null);

export function useStaff(): StaffApi {
  const value = useContext(StaffContext);
  if (!value) throw new Error("useStaff outside <StaffProvider>");
  return value;
}
